import { Injectable } from '@angular/core';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  private _email: string;
  private _password: string;

  private _user: User;

  public setUser(user: User) {
    this._user = user;
  }
  public getUser(): User {
    return this._user;
  }

  public getEmail(): string {
    return this._email;
  }
  public setEmail(value: string) {
    this._email = value;
  }

  public getPassword(): string {
    return this._password;
  }
  public setPassword(value: string) {
    this._password = value;
  }
}
